module.exports = __webpack_public_path__ + "img/terroir-liquify-4.300043f8.jpg";